import LoginForm from "../../components/auth/loginform/LoginForm";
export default function Login(){
    return(
        <>
            <LoginForm/>
        </>
    );
}